<template>
  <ul
    class="input-radio"
    :class="'input-radio--' + designType"
  >
    <li
      v-for="(item, index) in formSetting"
      :key="index"
      class="input-radio__item">
      <label
        class="radio-button"
        :class="'radio-button--' + designType"
      >
        <input
          :name="name"
          v-model="inputValue"
          :value="item.label"
          class="radio-button__input"
          type="radio"
        >
        <template v-if="designType === 'image'">
          <span
            class="radio-button__image"
            :style="'background-image: url(/static/img/favor/kantei_' + item.id + '.jpg)'"
          ></span>
          <span
            class="radio-button__image radio-button__image--on"
            :style="'background-image: url(/static/img/favor/kantei_' + item.id + '-on.jpg)'"
          ></span>
        </template>
        <template v-else-if="designType === 'frame'">
          <span class="radio-button__frame"></span>
        </template>
        <template v-else-if="designType === 'icon'">
          <span class="radio-button__icon"></span>
        </template>
        <span class="radio-button__text" v-html="item.value" :data-id="item.id"></span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  name: "InputRadio",
  props: {
    name: {
      type: String,
      default: ''
    },
    // デザインのタイプ
    designType: {
      type: String,
      default: ''
    },
    // 設定データ
    formSetting: {
      type: Array,
      default () {
        return []
      }
    },
    // ユーザーが入力したデータ
    inputedData: {
      type: String,
      default: ''
    }
  },
  computed: {
    // データバインディングした値
    inputValue: {
      get () {
        return this.inputedData
      },
      set (value) {
        this.$emit('change', value)
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.input-radio {
  $root: &;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  &__item {
    display: block;
  }
  &--image,
  &--frame {
    margin: -3px;
    @include mq('w320') {
      margin: -5px;
    }
    #{$root}__item {
      flex: 1 1 calc(33.33% - 6px);
      max-width: calc(33.33% - 6px);
      padding-bottom: calc(33.33% - 6px);
      margin: 3px;
      @include mq('w320') {
        flex: 1 1 calc(33.33% - 10px);
        max-width: calc(33.33% - 10px);
        padding-bottom: calc(33.33% - 10px);
        margin: 5px;
      }
      position: relative;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  &--icon {
    #{$root}__item {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.radio-button {
  $root: &;
  font-size: 13px;
  &__input {
    display: none;
  }
  &__text {
    display: inline-block;
    font-weight: bold;
    font-size: 13px;
    line-height: 16px;
    outline: none;
    @include mq('w320') {
      font-size: 15px;
    }
  }
  // designType === image
  &__image {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: block;
    background: no-repeat 50% 50%/contain;
    border-radius: 100px;
    overflow: hidden;
    &--on {
      opacity: 0;
      transition: 0.2s;
      z-index: 2;
    }
  }
  &__input:checked ~ &__image--on {
    opacity: 1;
  }
  &--image #{$root}__text {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 5;
    transform: translate(-50%, calc(-50% + 1.5px));
    color: #fff;
    text-align: center;
    text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    white-space: nowrap;
  }
  // designType === frame
  &__frame {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: block;
    background: linear-gradient(135deg, #FF7497 25%, #CB8BFF 75%);
    border-radius: 100px;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 2px;
      z-index: 2;
      display: block;
      background: #fff;
      border-radius: 100px;
    }
  }
  &--frame {
    #{$root}__text {
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 5;
      transform: translate(-50%, calc(-50% + 1.5px));
      text-align: center;
      white-space: nowrap;
      color: $col_temp_key1;
      background: $col_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      &[data-id="relationship4"] {
        font-size: 14px;
        letter-spacing: -1px;
      }
    }
    #{$root}__input:checked ~ {
      #{$root}__frame::before {
        display: none;
      }
      #{$root}__text {
        -webkit-text-fill-color: initial;
        background: none;
        color: #fff;
      }
    }
  }
  // designType === icon
  &__icon {
    position: relative;
    display: inline-block;
    width: 21px;
    height: 21px;
    border: 1px solid $col_temp_gray3;
    border-radius: 100%;
    vertical-align: -5px;
    transition: 0.2s;
  }
  &--icon {
    #{$root}__text {
      font-weight: 400;
    }
  }
  &__input:checked ~ #{$root}__icon {
    border-color: $col_temp_gray3;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 13px;
      height: 13px;
      background: $col_temp_key1;
      border-radius: 10px;
    }
    ~ #{$root}__text {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/InputRadio.vue